<p class="tw-font-sans tw-text-sm tw-text-eerie-black sm:tw-mt-10 sm:tw-px-0 sm:tw-text-base">
  {{ 'screens.reporterInformation.requiredFields' | translate }}
</p>

<form
  (ngSubmit)="reporterInformationFacade.onNext()"
  [formGroup]="reporterInformationFacade.reporterInformationForm"
  iaInvalidControlScroll
>
  <ia-panel class="tw-mt-4 tw-block">
    <div header class="">
      <span class="tw-pl-3 tw-text-lg tw-font-semibold tw-text-eerie-black">{{
        'screens.reporterInformation.information.title' | translate
      }}</span>
    </div>
    <div content class="tw-px-8 tw-pb-6 tw-pt-5">
      <p class="tw-font-sans tw-text-base">
        {{ 'screens.reporterInformation.information.description' | translate }}
      </p>

      <div class="tw-flex tw-flex-col">
        <div class="tw-mt-7.5">
          <label
            class="tw-font-sans tw-text-base tw-font-semibold"
            id="label-reporter-information-gender"
            for="input-reporter-information-gender"
          >
            {{ 'screens.reporterInformation.information.gender.label' | translate }}</label
          >
          @for (object of successionFacade.listBoxItems.gender; track object; let index = $index) {
            <ia-radio-button
              aria-describedby="gender"
              class="first-letter:tw-uppercase"
              type="radio"
              [value]="object.value"
              groupName="gender"
              formControlName="gender"
            >
              {{ object.label }}
            </ia-radio-button>
          }
          @if (
            reporterInformationFacade.gender.touched && reporterInformationFacade.gender.invalid
          ) {
            <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
              {{ 'screens.reporterInformation.information.gender.error' | translate }}
            </p>
          }
        </div>

        <div class="tw-mt-7.5 tw-flex tw-flex-col">
          <label
            class="tw-font-sans tw-text-base tw-font-semibold"
            id="label-reporter-information-name"
            name="reporter-information-name"
            for="input-reporter-information-name"
            >{{ 'screens.reporterInformation.information.name.label' | translate }}</label
          >
          <input
            [error]="
              reporterInformationFacade.name.touched && reporterInformationFacade.name.invalid
            "
            [patterns]="successionFacade.numbersAndSpecialCharactersNotAllowed"
            iaInput
            class="tw-w-full md:tw-w-1/2"
            formControlName="name"
            id="input-reporter-information-name"
            data-test-id="input-reporter-information-name"
            mask="A*"
            [specialCharacters]="[' -', 'space']"
            maxlength="32"
            name="name"
          />
          @if (reporterInformationFacade.name.touched && reporterInformationFacade.name.invalid) {
            <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
              {{ 'screens.reporterInformation.information.name.error' | translate }}
            </p>
          }
        </div>

        <div class="tw-mt-7.5 tw-flex tw-flex-col">
          <label
            class="tw-font-sans tw-text-base tw-font-semibold"
            for="input-reporter-information-birth-name"
            id="label-reporter-information-birth-name"
            name="reporter-information-birth-name"
            >{{ 'screens.reporterInformation.information.birthname' | translate }}
          </label>
          <input
            [patterns]="successionFacade.numbersAndSpecialCharactersNotAllowed"
            iaInput
            formControlName="birthname"
            class="tw-w-full md:tw-w-1/2"
            id="input-reporter-information-birth-name"
            data-test-id="input-reporter-information-birth-name"
            mask="A*"
            [specialCharacters]="[' -', 'space']"
            maxlength="32"
            name="birthname"
          />
        </div>

        <div class="tw-mt-7.5 tw-flex tw-flex-col">
          <label
            class="tw-font-sans tw-text-base tw-font-semibold"
            for="input-reporter-information-first-name"
            id="label-reporter-information-first-name"
            name="reporter-information-first-name"
            >{{ 'screens.reporterInformation.information.firstname.label' | translate }}</label
          >
          <input
            [error]="
              reporterInformationFacade.firstname.touched &&
              reporterInformationFacade.firstname.invalid
            "
            [patterns]="successionFacade.numbersAndSpecialCharactersNotAllowed"
            iaInput
            class="tw-w-full md:tw-w-1/2"
            formControlName="firstname"
            id="input-reporter-information-first-name"
            data-test-id="input-reporter-information-first-name"
            mask="A*"
            [specialCharacters]="[' -', 'space']"
            maxlength="32"
            name="firstname"
          />
          @if (
            reporterInformationFacade.firstname.touched &&
            reporterInformationFacade.firstname.invalid
          ) {
            <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
              {{ 'screens.reporterInformation.information.firstname.error' | translate }}
            </p>
          }
        </div>

        <div class="tw-mt-7.5 tw-flex tw-flex-col">
          <label
            class="tw-font-sans tw-text-base tw-font-semibold"
            id="label-reporter-information-relationshipWithDeceased"
            for="input-reporter-information-relationshipWithDeceased"
            name="reporter-information-relationshipWithDeceased"
            >{{
              'screens.reporterInformation.information.relationshipWithDeceased.label' | translate
            }}</label
          >
          <ia-listbox2
            formControlName="relationshipWithDeceased"
            [overlayOverrides]="listBoxOverlayConfig"
            class="tw-mt-2.5 tw-w-full md:tw-w-1/2"
            triggerId="input-reporter-information-relationshipWithDeceased"
            triggerAriaLabelledBy="label-reporter-information-relationshipWithDeceased"
          >
            <div *iaListbox2Placeholder>
              {{
                'screens.reporterInformation.information.relationshipWithDeceased.placeholder'
                  | translate
              }}
            </div>

            @for (
              option of successionFacade.listBoxItems.relationshipWithDeceasedList;
              track option.value
            ) {
              <ia-listbox2-option [value]="option.value">
                {{ option.label }}
              </ia-listbox2-option>
            }
          </ia-listbox2>

          @if (
            reporterInformationFacade.relationshipWithDeceased.touched &&
            reporterInformationFacade.relationshipWithDeceased.invalid
          ) {
            <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
              {{
                'screens.reporterInformation.information.relationshipWithDeceased.error' | translate
              }}
            </p>
          }
        </div>

        <div class="tw-mt-7.5 tw-flex tw-flex-col">
          <label
            class="tw-font-sans tw-text-base tw-font-semibold"
            id="label-reporter-information-country"
            for="input-reporter-information-country"
            name="reporter-information-country"
            >{{ 'screens.reporterInformation.information.country.label' | translate }}</label
          >
          <ia-listbox2
            formControlName="country"
            [overlayOverrides]="listBoxOverlayConfig"
            class="tw-mt-2.5 tw-w-full md:tw-w-1/2"
            triggerId="input-reporter-information-country"
            triggerAriaLabelledBy="label-reporter-information-country"
          >
            <div *iaListbox2Placeholder>
              {{ 'screens.reporterInformation.information.country.placeholder' | translate }}
            </div>

            @for (option of successionFacade.listBoxItems.countries; track option.value) {
              <ia-listbox2-option [value]="option.value">
                {{ option.label }}
              </ia-listbox2-option>
            }
          </ia-listbox2>
          @if (
            reporterInformationFacade.country.touched && reporterInformationFacade.country.invalid
          ) {
            <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
              {{ 'screens.reporterInformation.information.country.error' | translate }}
            </p>
          }
        </div>

        <div class="tw-mt-7.5 tw-flex tw-flex-col">
          <label
            class="tw-font-sans tw-text-base tw-font-semibold"
            id="label-reporter-information-address"
            name="reporter-information-address"
            for="input-reporter-information-address"
            >{{ 'screens.reporterInformation.information.address.label' | translate }}</label
          >
          <input
            [error]="
              reporterInformationFacade.address.touched && reporterInformationFacade.address.invalid
            "
            [patterns]="successionFacade.specialCharactersNotAllowed"
            iaInput
            class="tw-w-full md:tw-w-1/2"
            formControlName="address"
            id="input-reporter-information-address"
            data-test-id="input-reporter-information-address"
            mask="A*"
            [specialCharacters]="[' -', 'space']"
            maxlength="50"
            name="address"
          />
          @if (
            reporterInformationFacade.address.touched && reporterInformationFacade.address.invalid
          ) {
            <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
              {{ 'screens.reporterInformation.information.address.error' | translate }}
            </p>
          }
        </div>

        <div class="tw-mt-7.5 tw-flex tw-flex-col">
          <label
            class="tw-font-sans tw-text-base tw-font-semibold"
            for="input-reporter-information-additional-address"
            id="label-reporter-information-additional-address"
            name="reporter-information-additional-address"
            >{{ 'screens.reporterInformation.information.complementaryAddress' | translate }}</label
          >
          <input
            [patterns]="successionFacade.specialCharactersNotAllowed"
            iaInput
            class="tw-w-full md:tw-w-1/2"
            id="input-reporter-information-additional-address"
            data-test-id="input-reporter-information-additional-address"
            mask="A*"
            [specialCharacters]="[' -', 'space']"
            maxlength="50"
            formControlName="complementaryAddress"
            name="complementaryAddress"
          />
        </div>

        <div class="tw-mt-7.5 tw-flex tw-flex-col">
          <div class="tw-flex-row">
            <label
              class="tw-font-sans tw-text-base tw-font-semibold"
              for="input-reporter-information-zip-code"
              id="label-reporter-information-zip-code"
            >
              {{ 'screens.reporterInformation.information.zipcode.label' | translate }}
            </label>
            @if (reporterInformationFacade.country.value !== countryFrance) {
              <span class="tw-font-sans tw-text-base tw-font-semibold">
                {{ 'screens.deceasedInformation.information.optional' | translate }}</span
              >
            }
          </div>
          <input
            [error]="
              reporterInformationFacade.zipcode.touched && reporterInformationFacade.zipcode.invalid
            "
            [mask]="reporterInformationFacade.country.value === countryFrance ? 'AAAAA' : 'A*'"
            [patterns]="successionFacade.specialCharactersNotAllowed"
            iaInput
            class="tw-w-full md:tw-w-1/2"
            formControlName="zipcode"
            id="input-reporter-information-postal-code"
            data-test-id="input-reporter-information-postal-code"
            maxlength="32"
            name="zipcode"
          />
          @if (
            reporterInformationFacade.zipcode.touched && reporterInformationFacade.zipcode.invalid
          ) {
            <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
              {{ 'screens.reporterInformation.information.zipcode.error' | translate }}
            </p>
          }
        </div>

        <div class="tw-mt-7.5 tw-flex tw-flex-col">
          <div class="tw-flex-row">
            <label
              class="tw-font-sans tw-text-base tw-font-semibold"
              id="label-reporter-information-city"
              name="reporter-information-city"
              for="input-reporter-information-city"
              >{{ 'screens.reporterInformation.information.city.label' | translate }}</label
            >
            @if (reporterInformationFacade.country.value !== countryFrance) {
              <span class="tw-font-sans tw-text-base tw-font-semibold">
                {{ 'screens.deceasedInformation.information.optional' | translate }}</span
              >
            }
          </div>
          <input
            [error]="
              reporterInformationFacade.city.touched && reporterInformationFacade.city.invalid
            "
            [patterns]="successionFacade.numbersAndSpecialCharactersNotAllowed"
            iaInput
            class="tw-w-full md:tw-w-1/2"
            formControlName="city"
            id="input-reporter-information-city"
            data-test-id="input-reporter-information-city"
            mask="A*"
            [specialCharacters]="[' -', 'space']"
            maxlength="32"
            name="city"
          />
          @if (reporterInformationFacade.city.touched && reporterInformationFacade.city.invalid) {
            <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
              {{ 'screens.reporterInformation.information.city.error' | translate }}
            </p>
          }
        </div>

        <div class="tw-mt-7.5 tw-flex tw-flex-col">
          <label
            class="tw-font-sans tw-text-base tw-font-semibold"
            id="label-reporter-information-email"
            for="label-reporter-information-email"
            >{{ 'screens.reporterInformation.information.email.label' | translate }}</label
          >

          <input
            [error]="
              reporterInformationFacade.email.touched && reporterInformationFacade.email.invalid
            "
            iaInput
            class="tw-w-full md:tw-w-1/2"
            formControlName="email"
            id="input-reporter-information-email"
            data-test-id="input-reporter-information-email"
            maxlength="100"
            name="email"
          />

          @if (reporterInformationFacade.email.touched && reporterInformationFacade.email.invalid) {
            <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
              {{ 'screens.reporterInformation.information.email.error' | translate }}
            </p>
          }
          <p class="tw-pt-3 tw-font-sans tw-text-sm tw-text-gray">
            {{ 'screens.reporterInformation.information.email.information' | translate }}
          </p>
        </div>

        <div class="tw-mt-7.5 tw-flex tw-flex-col">
          <label
            class="tw-font-sans tw-text-base tw-font-semibold"
            id="label-reporter-information-email"
            for="input-reporter-information-emailConfirmation"
            >{{
              'screens.reporterInformation.information.emailConfirmation.label' | translate
            }}</label
          >

          <input
            [error]="
              reporterInformationFacade.emailConfirmation.touched &&
              reporterInformationFacade.emailConfirmation.invalid
            "
            iaBlockCopyPaste
            iaInput
            class="tw-w-full md:tw-w-1/2"
            formControlName="emailConfirmation"
            id="input-reporter-information-emailConfirmation"
            data-test-id="input-reporter-information-emailConfirmation"
            maxlength="100"
            name="emailConfirmation"
          />

          @if (
            reporterInformationFacade.emailConfirmation.touched &&
            reporterInformationFacade.emailConfirmation.hasError('invalidEmail')
          ) {
            <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
              {{ 'screens.reporterInformation.information.email.error' | translate }}
            </p>
          }
          @if (
            reporterInformationFacade.emailConfirmation.dirty &&
            reporterInformationFacade.reporterInformationForm.hasError('invalidEmailComparaison')
          ) {
            <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
              {{ 'screens.reporterInformation.information.emailConfirmation.error' | translate }}
            </p>
          }
          @if (
            reporterInformationFacade.emailConfirmation.touched &&
            reporterInformationFacade.emailConfirmation.invalid
          ) {
            <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
              {{ 'screens.reporterInformation.information.emailConfirmation.error2' | translate }}
            </p>
          }
        </div>

        <div class="tw-mt-7.5 tw-flex tw-flex-col">
          <label
            class="tw-font-sans tw-text-base tw-font-semibold"
            id="label-reporter-information-phone"
            for="input-reporter-information-phoneNumber"
            name="reporter-information-phone"
            >{{ 'screens.reporterInformation.information.phoneNumber.label' | translate }}</label
          >

          <input
            [error]="
              reporterInformationFacade.phoneNumber.touched &&
              reporterInformationFacade.phoneNumber.invalid
            "
            iaInput
            class="tw-w-full md:tw-w-1/2"
            id="input-reporter-information-phoneNumber"
            data-test-id="input-reporter-information-phoneNumber"
            maxlength="20"
            formControlName="phoneNumber"
          />

          @if (
            reporterInformationFacade.phoneNumber.touched &&
            reporterInformationFacade.phoneNumber.invalid
          ) {
            <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
              {{ 'screens.reporterInformation.information.phoneNumber.error' | translate }}
            </p>
          }
          <p class="tw-pt-3 tw-font-sans tw-text-sm tw-text-gray">
            {{ 'screens.reporterInformation.information.phoneNumber.information' | translate }}
          </p>
        </div>

        <div class="tw-mt-7.5 tw-flex tw-flex-col">
          <label
            class="tw-font-sans tw-text-base tw-font-semibold"
            id="label-reporter-information-commentary"
            for="commentary"
            name="reporter-information-commentary"
            >{{ 'screens.reporterInformation.information.commentary.label' | translate }}</label
          >
          <textarea
            [patterns]="successionFacade.specialCharactersNotAllowed"
            [placeholder]="
              'screens.reporterInformation.information.commentary.placeholder' | translate
            "
            class="tw-mt-2.5 tw-block tw-h-51 tw-w-full tw-appearance-none tw-rounded-[3px] tw-border tw-border-solid tw-px-4 tw-py-3 tw-font-sans tw-leading-tight tw-shadow-inner focus:tw-outline-none md:tw-w-1/2"
            formControlName="commentary"
            iaBlockCopyPaste
            mask="A*"
            [specialCharacters]="[' -', 'space']"
            maxlength="200"
            data-test-id="commentary"
            id="commentary"
          ></textarea>

          <p class="tw-pt-3 tw-font-sans tw-text-sm tw-text-gray">
            {{ 'screens.reporterInformation.information.commentary.information' | translate }}
          </p>
        </div>
      </div>
    </div></ia-panel
  >

  @if (
    {
      isLoading: successionFacade.customerInformationIsLoading$ | async,
      isPrevious: successionFacade.isPreviousPageLoading$ | async,
      isNext: successionFacade.isNextPageLoading$ | async,
    };
    as vm
  ) {
    <div
      class="tw-mt-5 tw-flex tw-flex-col tw-items-center tw-justify-end tw-space-x-2 sm:tw-flex-row"
    >
      <button
        (click)="reporterInformationFacade.onPrevious()"
        [disabled]="vm.isLoading"
        [isProcessing]="!!vm.isLoading && !!vm.isPrevious"
        iaButton
        id="btn-notary-more-information-previous"
        data-test-id="btn-notary-more-information-previous"
        type="button"
        variant="secondary"
      >
        {{ 'screens.notaryInformation.information.button.previous' | translate }}
      </button>
      <button
        [disabled]="vm.isLoading"
        [isProcessing]="!!vm.isLoading && !!vm.isNext"
        iaButton
        id="btn-notary-information-next"
        data-test-id="btn-notary-information-next"
        type="submit"
        variant="primary"
      >
        {{ 'screens.notaryInformation.information.button.next' | translate }}
      </button>
    </div>
  }
</form>
